export const ALERTAS_DESCRIPCIONES: { [key: number]: string } = {
  2: "Se enviarán notificaciones cuando ocurra un error al enviar documentos al SII.",
  3: "Se enviarán notificaciones cuando falle el envío de email al receptor del documento.",
  4: "Se enviarán notificaciones cuando el receptor rechace un documento DTE.",
  5: "Se enviarán notificaciones cuando la cantidad de folios disponibles sea baja.",
  6: "Se enviarán notificaciones cuando no haya folios disponibles.",
  7: "Se enviarán notificaciones próximo a la fecha de caducidad de los folios.",
  8: "Se enviarán notificaciones próximo a la fecha de caducidad del certificado digital.",
  9: "Se enviarán notificaciones cuando no haya certificado digital disponible.",
  11: "Se enviarán notificaciones cuando la sesión del usuario sea bloqueada.",
  13: "Se enviarán notificaciones por cada emisión de documento (DTE, Boleta, Guía de Despacho, etc.) desde la APP o API.",
  14: "Se enviarán notificaciones cuando un DTE sea rechazado por el SII.",
  15: "Se enviarán notificaciones cuando se reciba un reparo en un DTE.",
  16: "Se enviarán notificaciones cuando se alcance el límite de DTEs que pueden ser emitidos.",
  17: "Se enviarán notificaciones cuando la contraseña del SII sea incorrecta.",
  18: "Se enviarán notificaciones cuando ocurra un error al generar o enviar un DTE.",
};

export function getAlertaDescripcion(id: number): string {
  return ALERTAS_DESCRIPCIONES[id] || "Descripción no disponible";
}
